export default {
  FETCH_SEARCH_SUGGESTION: 'FETCH_SEARCH_SUGGESTION',
  FETCH_TRENDING_SEARCHES: 'FETCH_TRENDING_SEARCHES',
  UPDATE_SEARCH_FIELD: 'UPDATE_SEARCH_FIELD',
  RESET_SEARCH: 'search/reset',
  TOGGLE_VOICE_Modal: 'TOGGLE_VOICE_Modal',
  FETCH_POPULAR_SUGGESTIONS: 'FETCH_POPULAR_SUGGESTIONS',
  FETCH_POPULAR_SUGGESTIONS_FAIL: 'search/FETCH_POPULAR_SUGGESTIONS_FAIL',
  FETCH_RECENTLY_VIEWED_PRODUCTS: 'search/fetchRecentlyViewedProducts',
  FETCH_SEARCH_SUGGESTION_WIDGETS_PROGRESS:
    'search/SEARCH_SUGGESTION_WIDGETS_PROGRESS',
  FETCH_SEARCH_SUGGESTION_WIDGETS_SUCCESS:
    'search/SEARCH_SUGGESTION_WIDGETS_SUCCESS',
  FETCH_SEARCH_SUGGESTION_WIDGETS_FAIL:
    'search/SEARCH_SUGGESTION_WIDGETS_SUCCESS',
};
